import { Link } from "react-router-dom";

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="mb-7 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.28em] text-primary-300">
            <span className="h-px w-6 bg-primary-500/70"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl font-semibold leading-tight text-foreground-950 md:text-[26px]">{title}</h2>
        {description && (
          <p className="mt-2 max-w-2xl text-[13px] leading-relaxed text-foreground-500">{description}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/70 px-3.5 py-2 font-label text-xs text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-200"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-[13px]"></i>
        </Link>
      )}
    </div>
  );
}